<template>
  <v-dialog v-model="show" width="700px" height v-if="data != null" persistent>
    <v-card class="pa-4">
      <div class="overline mb-2" style="font-size: 16px !important">
        Zarządzanie dostępnością i czasem dostawy
      </div>
      <v-row no-gutters class="mt-2 ml-2">
        <v-switch
          v-model="useAutomaticAvailability"
          @change="updateAutomaticAvailability"
          label="Automatyczne zarządzanie statusem dostępności (zgodnie z konfiguracją shoper)"
          dense
        ></v-switch>
      </v-row>
      <v-row no-gutters class="mt-1 ml-2">
        <v-select
          v-model="selectedInStockAvailability"
          v-show="!useAutomaticAvailability"
          :items="formattedAvailabilities"
          label="Status w przypadku dodatniej dostępności"
          outlined
          dense
        ></v-select>
      </v-row>
      <v-row no-gutters class="mt-1 ml-2">
        <v-select
          v-model="selectedNoStockAvailability"
          v-show="!useAutomaticAvailability"
          :items="formattedAvailabilities"
          label="Status w przypadku zerowej dostępności"
          outlined
          dense
        ></v-select>
      </v-row>
      <v-divider class="mb-7"></v-divider>
      <v-row no-gutters class="mt-1 ml-2">
        <v-select
          v-model="selectedInStockDelivery"
          :items="formattedDeliveries"
          label="Status w przypadku dodatniej dostępności"
          outlined
          dense
        ></v-select>
      </v-row>
      <v-row no-gutters class="mt-1 ml-2">
        <v-select
          v-model="selectedNoStockDelivery"
          :items="formattedDeliveries"
          label="Status w przypadku zerowej dostępności"
          outlined
          dense
        ></v-select>
      </v-row>
      <v-row no-gutters class="mt-5 ml-2">
        <v-col class="text-right">
          <v-btn @click="saveOffer()" class="mr-1" color="primary"
            >Zapisz</v-btn
          >
          <v-btn
            outlined
            @click="
              () => {
                resetData();
                $emit('input', false);
              }
            "
            class="mr-1"
            >Zamknij</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  methods: {
    saveOffer() {
      this.$store
        .dispatch("saveRwcOfferDeliveryAndAvailability", {
          id: this.data.id,
          useAutomaticAvailability: this.useAutomaticAvailability,
          inStockAvailabilityId: this.selectedInStockAvailability?.id || null,
          inStockAvailabilityName:
            this.selectedInStockAvailability?.name || null,
          noStockAvailabilityId: this.selectedNoStockAvailability?.id || null,
          noStockAvailabilityName:
            this.selectedNoStockAvailability?.name || null,
          inStockDeliveryId: this.selectedInStockDelivery?.id || null,
          inStockDeliveryName: this.selectedInStockDelivery?.name || null,
          noStockDeliveryId: this.selectedNoStockDelivery?.id || null,
          noStockDeliveryName: this.selectedNoStockDelivery?.name || null,
        })
        .then(() => {
          this.$store.dispatch("snackbar/setSnackbar", {
            color: "success",
            text: "Zaktualizowano!",
          });
          this.data.useAutomaticAvailability = this.useAutomaticAvailability;
          this.data.inStockAvailabilityId =
            this.selectedInStockAvailability?.id || null;
          this.data.inStockAvailabilityName =
            this.selectedInStockAvailability?.name || null;
          this.data.noStockAvailabilityId =
            this.selectedNoStockAvailability?.id || null;
          this.data.noStockAvailabilityName =
            this.selectedNoStockAvailability?.name || null;
          this.data.inStockDeliveryId =
            this.selectedInStockDelivery?.id || null;
          this.data.inStockDeliveryName =
            this.selectedInStockDelivery?.name || null;
          this.data.noStockDeliveryId = this.selectedNoStockDelivery?.id;
          this.data.noStockDeliveryName = this.selectedNoStockDelivery?.name;
          this.$emit("input", false);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAvailabilitiesAndDeliveries() {
      if (this.availabilities.length === 0) {
        this.$store
          .dispatch("getAvailabilities")
          .then((success) => {
            this.availabilities = success.data;
            this.initializeValues();
          })
          .catch((error) => {
            console.log(error);
          });
      }

      if (this.deliveries.length === 0) {
        this.$store
          .dispatch("getDeliveries")
          .then((success) => {
            this.deliveries = success.data;
            this.initializeValues();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    initializeValues() {
      this.useAutomaticAvailability =
        this.data?.useAutomaticAvailability || false;

      if (this.availabilities.length > 0) {
        this.selectedInStockAvailability =
          this.availabilities.find(
            (item) => item.id === this.data?.inStockAvailabilityId
          ) || null;
        this.selectedNoStockAvailability =
          this.availabilities.find(
            (item) => item.id === this.data?.noStockAvailabilityId
          ) || null;
      }

      if (this.deliveries.length > 0) {
        this.selectedInStockDelivery =
          this.deliveries.find(
            (item) => item.id === this.data?.inStockDeliveryId
          ) || null;
        this.selectedNoStockDelivery =
          this.deliveries.find(
            (item) => item.id === this.data?.noStockDeliveryId
          ) || null;
      }
    },
    resetData() {
      this.useAutomaticAvailability = false;
      this.selectedInStockAvailability = null;
      this.selectedNoStockAvailability = null;
      this.selectedInStockDelivery = null;
      this.selectedNoStockDelivery = null;
    },
    updateAutomaticAvailability(value) {
      this.useAutomaticAvailability = value;
    },
  },
  props: {
    value: Boolean,
    data: {
      type: Object,
    },
  },
  mounted() {
    this.getAvailabilitiesAndDeliveries();
  },
  data() {
    return {
      deliveries: [],
      availabilities: [],
      useAutomaticAvailability: false,
      selectedInStockAvailability: null,
      selectedNoStockAvailability: null,
      selectedInStockDelivery: null,
      selectedNoStockDelivery: null,
    };
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.initializeValues();
      }
    },
    data: {
      handler(newVal) {
        if (newVal) {
          this.initializeValues();
        }
      },
      deep: true,
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.resetData();
        }
        this.$emit("input", value);
      },
    },
    formattedDeliveries() {
      return this.deliveries.map((delivery) => ({
        ...delivery,
        text: `${delivery.name} (ID: ${delivery.id})`,
        value: delivery,
      }));
    },
    formattedAvailabilities() {
      return this.availabilities.map((availability) => ({
        ...availability,
        text: `${availability.name} (ID: ${availability.id})`,
        value: availability,
      }));
    },
  },
};
</script>
